// Public API for the Program entity. No orchestrators today.

import * as endpoints from './endpoints';

const ProgramService = {
  ...endpoints,
};

export default ProgramService;
export type { ProgramData } from './endpoints';
